import { UserAction } from "../../app-constants/index.js";

const defaultState = {
  isLoading: false,
  items: [],
  showModal: false,
  modalData: {
    id: null,
    label: '',
    url: '',
    sortOrder: 0,
    isActive: 1,
  },
};

const trendingBarReducer = (state = defaultState, action) => {
  switch (action.type) {
    case UserAction.SET.ACTIVE_DOMAIN:
    case UserAction.SIGN_OUT.SUCCESS: {
      return defaultState;
    }
    case 'trendingBar.fetch.request': {
      return { ...state, isLoading: true };
    }
    case 'trendingBar.fetch.success': {
      return { ...state, isLoading: false, items: action.items || [] };
    }
    case 'trendingBar.fetch.failure': {
      return { ...state, isLoading: false };
    }
    case 'trendingBar.modal.toggle': {
      if (action.flag === false) {
        return { ...state, showModal: false, modalData: defaultState.modalData };
      }
      return { ...state, showModal: action.flag };
    }
    case 'trendingBar.modal.setData': {
      return {
        ...state,
        showModal: true,
        modalData: {
          id: action.item.id,
          label: action.item.label || '',
          url: action.item.url || '',
          sortOrder: action.item.sortOrder !== undefined ? action.item.sortOrder : (action.item.sort_order !== undefined ? action.item.sort_order : 0),
          isActive: action.item.isActive !== undefined ? action.item.isActive : (action.item.is_active !== undefined ? action.item.is_active : 1),
        },
      };
    }
    default:
      return state;
  }
};

export default trendingBarReducer;
